import ReplaceCardDialog from "./ReplaceCardDialog"
import type { SavedPaymentMethod } from "./model"
import { useT } from "@/i18n"
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/ui/components/ui/card"

type Props = {
  readonly card: SavedPaymentMethod | null
}

export default function PaymentMethodCard({ card }: Props) {
  const { t } = useT("money")

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("paymentMethod.title")}</CardTitle>
      </CardHeader>
      <CardContent className="flex items-center justify-between gap-4">
        {card ? (
          <div className="flex flex-col">
            <span className="capitalize">
              {t("paymentMethod.card", {
                brand: card.brand,
                last4: card.last4,
              })}
            </span>
            <span className="text-sm text-muted-foreground">
              {t("paymentMethod.expires", {
                month: card.expMonth,
                year: card.expYear,
              })}
            </span>
          </div>
        ) : (
          <span className="text-sm text-muted-foreground">
            {t("paymentMethod.none")}
          </span>
        )}
        <ReplaceCardDialog />
      </CardContent>
    </Card>
  )
}
